import(/* webpackMode: "eager", webpackExports: ["JobsView"] */ "/app/src/features/jobs/components/jobs-view.tsx");
